module.exports = __webpack_public_path__ + "img/05.c59e9e29.png";